import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  CREATE_BATCH_REQUEST,
  createBatchSuccess,
  createBatchFailure,
  FETCH_BATCHES_REQUEST,
  fetchBatchesSuccess,
  fetchBatchesFailure,
  DELETE_BATCH_REQUEST,
  deleteBatchSuccess,
  deleteBatchFailure,
  UPDATE_BATCH_REQUEST,
  updateBatchSuccess,
  updateBatchFailure,
  ASSIGN_BATCH_REQUEST,
  assignBatchSuccess,
  assignBatchFailure,
} from '../actions/batchActions';
import { useSelector } from 'react-redux';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { Authorization: `Bearer ${getAuthToken()}` },
});

function* createBatch(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/batchs`, action.payload.data, createConfig());
    yield put(createBatchSuccess(response.data));
  } catch (error) {
    yield put(createBatchFailure(error.response?.data?.message || error.message));
  }
}

function* fetchBatches(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching batches with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/batchs`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchBatchesSuccess(response.data));
  } catch (error) {
    console.error("Error fetching batches: ", error);
    yield put(fetchBatchesFailure(error.response?.data?.message || error.message));
  }
}


function* deleteBatch(action) {
  try {
    yield call(axios.delete, `${API_BASE_URL}/${action.payload.projectId}/batchs/${action.payload.id}`, createConfig());
    yield put(deleteBatchSuccess(action.payload));
  } catch (error) {
    yield put(deleteBatchFailure(error.response?.data?.message || error.message));
  }
}

function* updateBatch(action) {
  try {
    const { id, data,projectId } = action.payload;
    delete data.projectId
    delete data.knowledgeBaseIds
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/batchs/${id}`, data, createConfig());
    yield put(updateBatchSuccess(response.data));
  } catch (error) {
    yield put(updateBatchFailure(error.response?.data?.message || error.message));
  }
}

function* assignBatch(action) {
  try {
    const { id, teamIds } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/batchs/${id}/assign`, { teamIds }, createConfig());
    yield put(assignBatchSuccess(response.data));
  } catch (error) {
    yield put(assignBatchFailure(error.response?.data?.message || error.message));
  }
}

export default function* batchSaga() {
  yield takeLatest(CREATE_BATCH_REQUEST, createBatch);
  yield takeLatest(FETCH_BATCHES_REQUEST, fetchBatches);
  yield takeLatest(DELETE_BATCH_REQUEST, deleteBatch);
  yield takeLatest(UPDATE_BATCH_REQUEST, updateBatch);
  yield takeLatest(ASSIGN_BATCH_REQUEST, assignBatch);
}
